// export const loading = state => state.loading;

//=================================================================================================================

export const view = state => state.view;

//=================================================================================================================

// export const selection = state => state.selection;

// //=================================================================================================================

// export const all = state => state.registry.actions.flat;

// //=================================================================================================================

// export const popular = state => state.registry.actions.popular;

// //=================================================================================================================

// export const risk = state => state.registry.actions.byRisk;

// //=================================================================================================================

// export const categories = state => state.registry.categories;

// //=================================================================================================================

// export const logging = state => state.login.loading;

// //=================================================================================================================

// export const logged = state => !!state.login.user;

// //=================================================================================================================

// export const user = state => state.login.user;
